<div class="faq-page">
  <!-- ════════════════ HERO BANNER ════════════════ -->
  <header class="faq-hero">
    <div class="faq-hero-inner">
      <!-- Breadcrumb -->
      <nav class="faq-hero-breadcrumb">
        <a routerLink="/">Início</a>
        <i class="fas fa-chevron-right"></i>
        <span>Perguntas Frequentes</span>
      </nav>

      <!-- Eyebrow -->
      <div class="faq-hero-eyebrow">
        <i class="fas fa-circle-question"></i>
        <span>Central de Apoio e FAQ</span>
      </div>

      <!-- Title & Subtitle (Mesmos dizeres) -->
      <h1 class="faq-hero-title">
        Perguntas <em>Frequentes</em>
      </h1>

      <p class="faq-hero-desc">
        Tudo o que precisa de saber sobre o funcionamento da FundCube, criação de campanhas, processos de validação e
        segurança das doações.
      </p>

      <!-- Quick Topics Pills -->
      <div class="faq-hero-topics">
        <span class="topic-pill">
          <i class="fas fa-rocket"></i> Criação de Campanhas
        </span>
        <span class="topic-pill">
          <i class="fas fa-hand-holding-dollar"></i> Apoios e Doações
        </span>
        <span class="topic-pill">
          <i class="fas fa-shield-halved"></i> Segurança e Validação
        </span>
        <span class="topic-pill">
          <i class="fas fa-credit-card"></i> Pagamentos Multicaixa
        </span>
      </div>
    </div>

    <!-- Onda decorativa de transição inferior -->
    <div class="faq-hero-wave">
      <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <path d="M0,40 C360,80 1080,0 1440,40 L1440,60 L0,60 Z" fill="#f8fafb" />
      </svg>
    </div>
  </header>

  <!-- ════════════════ LISTAGEM ACCORDION ════════════════ -->
  <div class="container faq-main-content">
    <div class="faq-accordion-card">
      <p-accordion value="0">
        <p-accordion-panel *ngFor="let faq of faqs; let i = index; trackBy: trackByFn" [value]="i">
          <p-accordion-header>
            <ng-template #toggleicon let-active="active">
              <span class="flex items-center gap-3 w-full">
                <span class="faq-item-num">{{ i < 9 ? '0' + (i + 1) : (i + 1) }}</span>
                    <span class="faq-item-question" [class.active]="active">
                      {{ faq.pergunta }}
                    </span>
                </span>

                <div class="faq-toggle-icon" [class.active]="active">
                  <i class="fas" [ngClass]="active ? 'fa-minus' : 'fa-plus'"></i>
                </div>
            </ng-template>
          </p-accordion-header>

          <p-accordion-content>
            <div class="faq-answer-body">
              <p class="faq-answer-text">{{ faq.resposta }}</p>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>

      <div class="pagination-controls" *ngIf="(pagination.totalRecords ?? 0) > 5">
        <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
          [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
          (pageChange)="onPageChange($event)"></app-paginator-control>
      </div>
    </div>

    <!-- ════════════════ CONTACT CTA BOX ════════════════ -->
    <div class="faq-support-box">
      <div class="fsb-left">
        <div class="fsb-icon"><i class="fas fa-headset"></i></div>
        <div>
          <h3 class="fsb-title">Ainda tem alguma dúvida?</h3>
          <p class="fsb-desc">A nossa equipa de apoio está pronta para ajudar promotores e apoiadores em todo o
            processo.</p>
        </div>
      </div>
      <div class="fsb-actions">
        <a href="mailto:suporte@fundcube.ao" class="btn btn-primary">
          <i class="fas fa-envelope"></i> Fale Connosco
        </a>
      </div>
    </div>
  </div>

  <app-newsletter></app-newsletter>
</div>